import { Link } from "react-router-dom";

const LOGO_URL = "/logo.png";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-black border-t border-gold/20"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10 py-12 md:py-14">
                <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
                    {/* Brand */}
                    <div className="flex items-center gap-5">
                        <img
                            src={LOGO_URL}
                            alt="Nicholas Kraus Consulting"
                            className="h-14 w-14 object-contain flex-none"
                        />
                        <div>
                            <div className="font-display text-lg text-cream tracking-[0.14em] uppercase leading-tight">
                                Nicholas Kraus Consulting
                            </div>
                            <div className="text-[10px] tracking-[0.35em] text-gold uppercase mt-1">
                                Ohio · Est. January 2026
                            </div>
                        </div>
                    </div>

                    {/* Contact */}
                    <div className="flex flex-col md:items-end gap-2">
                        <a
                            href="mailto:nrkraus@nicholaskrausconsulting.com"
                            data-testid="footer-email"
                            className="text-cream/80 hover:text-gold transition-colors break-all text-sm md:text-base"
                        >
                            nrkraus@nicholaskrausconsulting.com
                        </a>
                        <a
                            href="tel:+19373213576"
                            data-testid="footer-phone"
                            className="font-display text-xl text-cream hover:text-gold transition-colors"
                        >
                            937 · 321 · 3576
                        </a>
                    </div>
                </div>

                <div className="mt-10 pt-6 border-t border-gold/10 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-[10px] uppercase tracking-[0.3em] text-cream/40">
                    <div>© {year} Nicholas Kraus Consulting LLC · All rights reserved</div>
                    <nav className="flex items-center gap-6">
                        <Link
                            to="/privacy"
                            data-testid="footer-privacy-link"
                            className="hover:text-gold transition-colors"
                        >
                            Privacy Policy
                        </Link>
                        <span className="text-cream/20">·</span>
                        <Link
                            to="/terms"
                            data-testid="footer-terms-link"
                            className="hover:text-gold transition-colors"
                        >
                            Terms &amp; Conditions
                        </Link>
                    </nav>
                </div>
            </div>
        </footer>
    );
}
